import React from "react";
import "./App.css";
import Header from "./components/Header/Header";
import MainPage from "./pages/MainPage/MainPage";
import Footer from "./components/Footer/Footer";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Registration from "./pages/Registration/Registration";
import Personal from "./pages/Personal/Personal";
import AuthRoute from "./components/AuthRoute/AuthRoute";
import Authorization from "./pages/Authorization/Authorization";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import PersonalData from "./components/PersonalData/PersonalData";
import CentersPage from "./pages/CentersPage/CentersPage";
import PrototypesPage from "./pages/PrototypesPage/PrototypesPage";
import EquipmentPage from "./pages/EquipmentPage/EquipmentPage";
import ServicesPage from "./pages/ServicesPage/ServicesPage";
import ResidentsPage from "./pages/ResidentsPage/ResidentsPage";
import AccountingPage from "./pages/AccountingPage/AccountingPage";
import CommonInfoPage from "./pages/CommonInfoPage/CommonInfoPage";
import { MainProvider } from "./context/MainContext";
import PostsPage from "./pages/PostsPage/PostsPage";
import EmployeePage from "./pages/EmployeePage/EmployeePage";
import ReportPage from "./pages/ReportPage/ReportPage";
import { ReportSchedulePage } from "./pages/ReportSchedulePage/ReportSchedulePage";
import { ReportControlPointsPage } from "./pages/ReportControlPointsPage/ReportControlPointsPage";
import { ReportScheduleEditPage } from "./pages/ReportScheduleEditPage/ReportScheduleEditPage";
import ContactsPage from "./pages/ContactPage/ContactsPage";
import { DocumentsPage } from "./pages/DocumentsPage/DocumentsPage";
import { OrderPage } from "./pages/OrderPage/OrderPage";

function App() {
    const router = useLocation();
    return (
        <MainProvider>
            <div className="App">
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<MainPage />} />
                        <Route path="/authorization" element={<Authorization />} />
                        <Route path="/forgot_password" element={<ForgotPassword />} />
                        <Route path="/registration" element={<Registration />}></Route>
                        <Route path="/personal" element={<AuthRoute />}>
                            <Route path="/personal" element={<Personal />}>
                                <Route index element={<Navigate to="centers" />} />
                                <Route path="data" element={<PersonalData />} />
                                <Route path="centers" element={<CentersPage />} />
                                <Route path="reportControlPoints" element={<ReportControlPointsPage />} />
                                <Route path="centers/:id" element={<Navigate to="data" />} />
                                <Route path="centers/:id/data" element={<CommonInfoPage />} />
                                <Route path="centers/:id/contacts" element={<ContactsPage />} />
                                <Route path="centers/:id/prototypes" element={<PrototypesPage />} />
                                <Route path="centers/:id/services" element={<ServicesPage />} />
                                <Route path="centers/:id/residents" element={<ResidentsPage />} />
                                <Route path="centers/:id/schedule" element={<EmployeePage />} />
                                <Route path="centers/:id/equipment" element={<EquipmentPage />} />
                                {/* <Route path="centers/:id/accounting" element={<AccountingPage />} /> */}
                                <Route path="centers/:id/events" element={<PostsPage />} />
                                <Route path="centers/:id/documents" element={<DocumentsPage />} />
                                <Route path="centers/:id/reports" element={<ReportPage />} />
                                <Route path="centers/:id/reportSchedule" element={<ReportSchedulePage />} />
                                <Route path="centers/:id/reportControlPoints" element={<ReportControlPointsPage />} />
                                <Route
                                    path="centers/:id/reportSchedule/:reportId"
                                    element={<ReportScheduleEditPage />}
                                />
                                {/* <Route path="centers/:id/orders" element={<OrderPage />} /> */}
                            </Route>
                        </Route>
                    </Routes>
                </main>
                {!router.pathname.includes("/personal") && <Footer />}
                <div />
            </div>
        </MainProvider>
    );
}

export default App;
